import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { injectStyles } from 'injectStyles';
import * as cssVariable from 'cssVariables';
import FaqAnswer from 'components/FaqAnswer';

const FaqQuestions = ({ classes, categorySlug, hasMoreButton, showAnswers, questions }) => (
  <Fragment>
    {questions &&
      questions.map(({ id, answerContent, question, slug }) => (
        <div key={id} data-testid="faq-question" className={classes.padding}>
          {showAnswers && answerContent ? (
            <Fragment>
              <p className={classes.question}>{question}</p>
              <div className={classes.answer}>
                <FaqAnswer
                  answerContent={[answerContent[0]]}
                  questionSlug={slug}
                  question={question}
                  hasFeedback={false}
                />
              </div>
              <NavLink
                className={classes.moreButton}
                to={`/veelgestelde-vragen/${categorySlug}/${slug}`}
                aria-label={`Ga naar ${categorySlug}`}
              >
                MEER
              </NavLink>
            </Fragment>
          ) : (
            <NavLink
              className={classes.link}
              to={`/veelgestelde-vragen/${categorySlug}/${slug}`}
              aria-label={`Ga naar ${question}`}
            >
              {question}
            </NavLink>
          )}
        </div>
      ))}
    {hasMoreButton && (
      <NavLink
        className={classes.moreButton}
        to={`/veelgestelde-vragen/${categorySlug}`}
        aria-label={`Ga naar ${categorySlug}`}
      >
        MEER
      </NavLink>
    )}
  </Fragment>
);
FaqQuestions.propTypes = {
  classes: PropTypes.object.isRequired,
  categorySlug: PropTypes.string.isRequired,
  hasMoreButton: PropTypes.bool,
  questions: PropTypes.array,
  showAnswers: PropTypes.bool,
};
FaqQuestions.defaultProps = {
  hasMoreButton: false,
  questions: null,
  showAnswers: false,
};

const styles = (theme) => ({
  padding: {
    padding: '10px 0',
  },
  question: {
    fontSize: 18,
    lineHeight: 1.33,
    color: theme.palette.text.primary,
    margin: '0 0 10px',
  },
  answer: {
    maxHeight: 60,
    overflow: 'hidden',
    position: 'relative',
    '& p': {
      margin: 0,
      fontSize: 18,
      lineHeight: '30px',
      color: theme.palette.text.secondary,
    },
    '&:after': {
      position: 'absolute',
      zIndex: 2,
      content: '""',
      left: 0,
      bottom: 0,
      height: 8,
      width: '100%',
      background: 'linear-gradient(rgba(255,255,255,0), rgba(255,255,255,1))',
    },
  },
  link: {
    fontSize: 18,
    lineHeight: 1.33,
    color: theme.palette.text.secondary,
    padding: '10px 0',
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.navigation.highlight,
    },
  },
  moreButton: {
    color: theme.palette.text.primary,
    fontSize: 14,
    fontWeight: cssVariable.fontWeights.bold,
    display: 'block',
    marginTop: 10,
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.navigation.highlight,
    },
  },
});

export default injectStyles(styles)(FaqQuestions);
